import { IProduct } from "src/types/product";

export const sendT2Sevent = (
  spaceId: string,
  product: IProduct,
  productIndex: number
): void => {
  const t2sPageParams = window._t2sparams;

  if (t2sPageParams != null) {
    const eventParams = {
      cID: t2sPageParams.cID,
      eN: t2sPageParams.eN,
      iID: product.id,
      lang: t2sPageParams.lang,
      pID: t2sPageParams.pID,
      po: String(productIndex),
      ru: product.url!,
      sp: `${t2sPageParams.cID}-${spaceId}`,
    };
    window.T2S.event("click", eventParams);
  }
};
